import validate from "/root/workspace/easygif-nuxt_6hOg/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqlite3@11.10.0_db0@0.3.2_ee9323554441fcc125ad2492cef02f02/node_modules/nuxt/dist/pages/runtime/validate.js";
import _01_45redirect404_45global from "/root/workspace/easygif-nuxt_6hOg/middleware/01.redirect404.global.ts";
import _02_45develop_45global from "/root/workspace/easygif-nuxt_6hOg/middleware/02.develop.global.ts";
import manifest_45route_45rule from "/root/workspace/easygif-nuxt_6hOg/node_modules/.pnpm/nuxt@3.17.4_@parcel+watcher@2.5.1_@types+node@22.15.21_better-sqlite3@11.10.0_db0@0.3.2_ee9323554441fcc125ad2492cef02f02/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  _01_45redirect404_45global,
  _02_45develop_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}